
import { Vue, Component, Prop } from 'vue-property-decorator';
import { GlobalOptions } from '@/enums/global/GlobalOptions';

@Component({
    name: 'NewProductNotification',
})
export default class NewProductNotification extends Vue {
    @Prop({ default: false }) private visible!: boolean;

    private closeModal() {
        this.$emit('close');
    }

    private triggerSystemSelection() {
        this.$emit('updateFormFields', [
            {
                pID: GlobalOptions.SISTEM_PID,
                value: 'KR 3',
                segment: 'Komarniki KR',
            },
        ]);
    }
}
